<template>
  <div :class="$style.container">
    <div :class="$style.loader">
      <img src="/icons/loading.svg" alt="" />
    </div>
  </div>
</template>

<style lang="scss" module>
.container {
  display: flex;
  flex-direction: column;
  position: fixed;
  z-index: 100;
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  background-color: $bg-separator;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  .loader {
    text-align: center;
    user-select: none;
    background-color: $bg-main;
    pointer-events: none;
    @include H2;
    padding: 3rem;
    border-radius: 2rem;
  }
}
</style>
<script setup></script>
